/**
 * Self-contained build-time feature flag for the Terms/Privacy/Referral
 * re-acceptance gate. Kept in its own file (mirrors FollowerFeed/featureFlag.js,
 * LinkedWheels/featureFlag.js) so it can be reviewed/merged independently.
 *
 * Defaults OFF; flipped per environment via REACT_APP_TERMS_ACCEPTANCE. When OFF
 * the gate never mounts and the acceptance-status API route is never called —
 * behaviour is byte-identical to today. Pairs with the backend
 * settings.TERMS_ACCEPTANCE_ENABLED (which reports nothing pending while OFF), so
 * a half-flipped state degrades safely: even with the FE flag ON, an OFF backend
 * returns no pending documents and the blocking modal never appears.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const TERMS_ACCEPTANCE_ENABLED = truthy(
  process.env.REACT_APP_TERMS_ACCEPTANCE
);
